import { render, staticRenderFns } from "./SubFolderDocumentIdentificator.vue?vue&type=template&id=9e3ef45c&scoped=true&"
import script from "./SubFolderDocumentIdentificator.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentIdentificator.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentIdentificator.vue?vue&type=style&index=0&id=9e3ef45c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3ef45c",
  null
  
)

export default component.exports